/*
 * This file contains all scripts that were declared directly in the Main.js before
 * Those functions should be seperated into own files for a better overview
 */

import './Project/globals';
import {Popover} from "bootstrap";
import { TouchSpin } from "./Project/Functions/TouchSpin";
import { RenderModal } from "./Project/Functions/RenderModal";
import DropdownHelper from ".//Project/Modules/Dropdown";

/**
 * Main Javascript
 */

// Test for media query support using modernizr
var mqSupport = Modernizr.mq('only all') ? true : false;
var mqGfbp = window.checkViewport('min-width: 992px');

window.addEventListener('resize', () => {
    mqGfbp = window.checkViewport('min-width: 992px');
    reInit();
}, {passive: true});

var mainNavigation = $('.main-navigation');

// Default Button Labels
var backButtonLabel = mainNavigation.data('back-button-label') || 'Zurück';
var topLevelButtonLabel = mainNavigation.data('toplevel-button-label') || 'Kategorien';
var parentButtonLabel = mainNavigation.data('parent-button-label');
var parentButtonLink = mainNavigation.data('parent-button-link');

$.ajaxSetup({cache: false});

var body = $('body');
var html = $('html');

// IE doesn't have window.location.origin
if (!window.location.origin) {
    window.location.origin = window.location.protocol + "//"
        + window.location.hostname
        + (window.location.port ? ':' + window.location.port : '');
}

// Set up Menu, accordeons, etc. depending on viewport dimensions
function init() {
    $('html.placeholder').removeClass('placeholder');

    // Footer.js

    if ($('.avency-nwd-products-productteaser .equalize-height').length > 0) {
        $('.avency-nwd-products-productteaser .equalize-height').equalHeights('reset').equalHeights();
    }

    if ($('.product-gallery-item.equalize-height').length > 0) {
        $('.product-gallery-item.equalize-height').equalHeights('reset').equalHeights();
    }
}

const orderDetails = $('.avency-nwd-account-order');
if (orderDetails.data('use-cached-fallback') == true) {
    var queryParams = getUrlVars();
    var cachedOrder = orderDetails.data('order-identifier');
    var cachedOrderSalesId = orderDetails.data('ax-sales-id');

    var order = queryParams['order[__identity]'];
    var orderSalesId = queryParams['axSalesId'];

    if (cachedOrder === order || cachedOrderSalesId === orderSalesId) {
        orderDetails.css('visibility', 'visible');
    } else {
        $('.cart-preview').hide();
        $('.user-product-lists-dropdown').hide();
        $('#loginbox').hide();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'cachedOrderDetails',
            'order': order,
            'orderSalesId': orderSalesId,
            'cachedOrder': cachedOrder,
            'cachedOrderSalesId': cachedOrderSalesId,
        });

        window.location.replace(orderDetails.data('cached-order-fallback'));
    }
}

// Setup navigations
$(document).ready(() => {
    init();

    const partnerCheckoutApplyModal = $('.partner-checkout-apply-modal');
    if (partnerCheckoutApplyModal.length > 0) {
        const modal = RenderModal.init('', partnerCheckoutApplyModal.html(), [], false, undefined, false, function (e) {
            location.href = partnerCheckoutApplyModal.data('partner-checkout-uri');
            return false;
        });

        modal.on('click touchend', 'input[type="submit"]', function() {
            var form = $(this).closest('form');
            if (form.find('input:checked').length < 1) {
                form.find('.alert').removeClass('hidden');
                return false;
            }

            form.find('.alert').addClass('hidden');
            $(this).attr('disabled', 'disabled');
            form.submit();
        })
    }
});

// reInit the JS
function reInit() {
    init();
}

// Reset after screen resize
$(window).smartresize(function () {
    reInit();
    resizeOpenSeadragon($('.openseadragon'));
    initArticleGallerySlider();
});

// Reinit after Neos PageLoad Event
if (typeof document.addEventListener === 'function') {
    document.addEventListener('Neos.PageLoaded', function (event) {
        reInit();
    }, false);
}

/**
 * Printing
 */

body.on('click touchend', '.print', function (e) {
    var uri = $('[data-print-url]').first().data('print-url');
    if (uri) {
        window.open(uri, '_blank');
    }
    e.stopPropagation();
});

/**
 * Order button
 */
$('#reviewAndOrder').submit(function (e) {
    $(this).submit(function () {
        return false;
    });

    var progressText = $(this).closest('div').data('progress-text');
    $(this).find("button[type='submit']").attr('disabled', 'disabled').html(progressText);
    return true;
});

$('.nav.nav-tabs').each(function () {
    $(this).tabCollapse();
});

/**
 * Initialize
 */
function initialize() {
    /**
     * Placeholder Polyfill to enable placeholders
     * in older browsers and password fields
     **/
    var inputs = $('input');
    if (inputs.length > 0) {
        inputs.inputPlaceholderPolyfill();
    }

    /**
     *
     * @param button
     */
    function toggleFormButtonLabel(button) {
        var newLabel = $(button).data('alternative-label');
        var oldLabel = $(button).find('em').text();

        $(button).data('alternative-label', oldLabel);
        $(button).find('em').text(newLabel);
    }

    function toggleFormElement(button) {
        var toggleId = $(button).data('toggle');
        toggleId = toggleId.replace('.', '\\.');
        var element = $(toggleId);
        element.toggle();
        $(window).scrollTo(toggleId, 1000, {offset: -50});
    }

    $('.form-toggle').each(function () {
        var disableField = $(this).nextAll('.disable-validation');
        var showStatus = $(this).nextAll('.show-form').val();
        if (showStatus == 1) {
            $(this).next('input[type=hidden]').val(1);
            disableField.val('');
            toggleFormElement(this);
            toggleFormButtonLabel(this);
            $(this).closest('div').addClass('open');

            $(this).siblings('*[data-toggle=true]').each(function () {
                $(this).toggle();
            });

        } else {
            $(this).next('input[type=hidden]').val(0);
            disableField.val($(this).data('disable-validation'));
        }
    });

    body.on('click touchend', '.form-toggle', function () {
        toggleFormElement(this);
        toggleFormButtonLabel(this);

        var showStatus = $(this).next('input[type=hidden]').val();
        if (showStatus == 1) {
            $(this).next('input[type=hidden]').val(0);
        } else {
            $(this).next('input[type=hidden]').val(1);
        }

        $(this).siblings('*[data-toggle=true]').each(function () {
            $(this).toggle();
        });

        var disableField = $(this).nextAll('.disable-validation');
        if (disableField.val() == '') {
            disableField.val($(this).data('disable-validation'));
        } else {
            disableField.val('');
        }

        return false;
    });

    var registrationToggleButton = $('#toggle-registration-elements');

    /**
     * Put request offer form input values into registration form
     */
    registrationToggleButton.on('click touchend', '', function () {
        $('.request-offers-form').hide();
        $('.avency-nwd-checkout-requestoffers .toggle-btn').show();

        var originalPrefix = '#requestOffers-requestOffers_';

        var salutation = $(originalPrefix + 'salutation').val();
        var title = $(originalPrefix + 'title').val();
        var firstName = $(originalPrefix + 'firstname').val();
        var lastName = $(originalPrefix + 'lastname').val();
        var company = $(originalPrefix + 'company').val();
        var company2 = $(originalPrefix + 'company2').val();
        var street = $(originalPrefix + 'street').val();
        var streetNumber = $(originalPrefix + 'streetNumber').val();
        var postalCode = $(originalPrefix + 'postalCode').val();
        var city = $(originalPrefix + 'city').val();
        var country = $(originalPrefix + 'country').val();
        var email = $(originalPrefix + 'email').val();
        var phone = $(originalPrefix + 'phone').val();
        var internet = $(originalPrefix + 'website').val();

        var targetPrefix = '#registration-registration_';
        $(targetPrefix + 'email').val(email);

        targetPrefix = '#registration-registration_contact_';
        $(targetPrefix + 'salutation').selectpicker('val', salutation);
        $(targetPrefix + 'title').selectpicker('val', title);
        $(targetPrefix + 'firstname').val(firstName);
        $(targetPrefix + 'lastname').val(lastName);
        $(targetPrefix + 'phone').val(phone);

        targetPrefix = '#registration-registration_invoice_';
        $(targetPrefix + 'company').val(company);
        $(targetPrefix + 'company2').val(company2);
        $(targetPrefix + 'firstname').val(firstName);
        $(targetPrefix + 'lastname').val(lastName);
        $(targetPrefix + 'street').val(street);
        $(targetPrefix + 'streetNumber').val(streetNumber);
        $(targetPrefix + 'postalCode').val(postalCode);
        $(targetPrefix + 'city').val(city);
        $(targetPrefix + 'country').selectpicker('val', country);
        $(targetPrefix + 'internet').val(internet);
    });

    if (registrationToggleButton.length > 0) {
        if (_get('click') !== undefined) {
            if (!(window.location.href.indexOf('#registration-registration.toggleElements') > -1)) {
                registrationToggleButton.trigger('click');
            }
        }
    }

    $('.avency-nwd-checkout-requestoffers .toggle-btn').on('click touchend', '', function () {
        $('.request-offers-form').show();
        $('#registration-registration\\.toggleElements').hide();
        $(this).hide();
    });

    // show guest request offer form if it has validation errors
    if ($('.request-offers-form .has-error').first().length > 0) {
        $('.avency-nwd-checkout-requestoffers .toggle-btn').trigger('click');
    }

    /**
     * Show additional field when 'Sonstige' is selected in dropdown
     */
    $('.form-other').find('select').each(function () {
        toggleFormOther($(this));
    });

    $('.form-other').find('select').on('change', function () {
        toggleFormOther($(this));
    });

    $('select.selectpicker').selectpicker({
        style: ''
    });

    /**
     * Product Description toggle
     */
    $('a.product-description-toggle').on('click touchend', function () {
        $('p.product-description-full').toggle();
        $('p.product-description-short').toggle();
        return false;
    });

    /**
     * Save last visited page and page type in cookie
     */
    $('a').on('click touchend', function (e) {
        var documentType = $('meta[name=document-type]').attr('content');
        var product = $(this).closest('[data-product]').data('product');

        window.setCookie('avency-nwd-shop-last-visited-page', window.location.href);
        window.setCookie('avency-nwd-shop-last-visited-document-type', documentType);

        if (product) {
            window.setCookie('avency-nwd-shop-product-referrer', product);
        }
    });

    var lastPage = window.getCookie('avency-nwd-shop-last-visited-page');
    var lastPageType = window.getCookie('avency-nwd-shop-last-visited-page');
    var backBtn = $('.back-button');
    if (lastPage && lastPageType === 'Avency.Nwd.Categories:PageCategory') {
        backBtn.find('a').attr('href', lastPage);
    }

    body.on('click touchend', '.submit-button', function () {
        var identifier = $(this).data('identifier');
        $(this).closest('input[name=buttonIdentifier]').val(identifier);
    });

    body.on('click touchend', '.btn-disable-on-clock', function () {
        $(this).attr('disabled', 'disabled');
    });

    /**
     * Load Product Video in a Modal-Box
     */
    body.on('click touchend', '.product-thumbnails span.video-thumbnail', function () {
        if (!window.checkViewport('min-width: 992px')) {
            openProductVideo($(this));
        } else if ($(this).parents('.article-content-layer').length === 0) {
            window.showArticleContentLayer('#article-content-layer-media');
        }
    });

    TouchSpin.init('input[type="number"]');
    const quantityInput = $('input.quantity-input');
    if (quantityInput.attr('type') === 'text') {
        TouchSpin.init(quantityInput.toArray());
    }

    /**
     * Handle article gallery
     */
    initArticleGallerySlider();
    $(document).articleGallery();
    initializeProductZoom($('.product-gallery .openseadragon'));

    /**
     * Popover init
     */
    window.initAvailabilityPopovers();

    /**
     * Save invoiceaddress as shippingaddress to checkoutdata
     */

    var chooseAddress = function () {
        var link = $(this).data('link');
        var redirectUri = $(this).data('redirect');

        $.post(link, {}, function () {
            location.href = redirectUri;
        }, 'json');
    };

    body.on('click touchend', '.choose-invoiceaddress', chooseAddress);
    body.on('click touchend', '.choose-defaultaddress', chooseAddress);

    /**
     * Save shippingaddress to checkoutdata
     */
    body.on('click touchend', '.choose-shippingaddress', function () {
        var redirectUri = $(this).parents('.shipping-address-container').data('redirect');
        var link = $(this).data('link');
        var data = {
            addressIndex: $(this).data('address')
        };
        $.post(link, data, function () {
            location.href = redirectUri;
        }, 'json');
    });

    body.on('click touchend', '.add-all-btn', function () {
        addToCart(this, true);
        return false;
    });

    body.on('click touchend', '.add-teeth-btn', function () {
        var form = $('#tooth-product-form');
        addToCart(this, true, $(form).serialize());
        $(form).find('input').val('');
        return false;
    });

    body.on('click touchend', function (e) {
        var cartDropup = $('.shopping-cart-dropup');
        cartDropup.removeClass('open');
        cartDropup.trigger('hide.bs.dropdown')

        const shoppingButtonPopovers = document.querySelectorAll('.shopping-button-dropup-popover');
        shoppingButtonPopovers.forEach((popoverEl) => {
            if (!(popoverEl.contains(e.target) || (e.target === popoverEl))) {
                popoverEl.remove();
            }
        });
    });

    /** Close dropdowns when gallery mouseover closes **/

    body.on('mouseleave', '.product-gallery-item-details', function () {
        $('.shopping-cart-dropup').removeClass('open');
    });

    body.on('change', 'form[name="product-filter"] .filter', function (e) {
        var modalBody = $(this).parents('.bootbox-body');
        var form = $(this).parents('form');
        var filterElements = form.find('.filter');
        var filters = {};
        filterElements.each(function () {
            filters[$(this).attr('name')] = $(this).val();
        });

        if (modalBody.length > 0) {
            $.ajax({
                url: form.attr('action'),
                data: filters
            }).done(function (data) {
                modalBody.html(data);
                initializeProductZoom($('.product-gallery .openseadragon'));

                TouchSpin.init('input[type="number"]');
                if ($('input').attr('type') === 'text') {
                    TouchSpin.init('input.quantity-input');
                }
            });
        } else {
            form.submit();
        }
    });

    /**
     * Handle Login via RegisterForm
     */
    var registerForm = $('#registration');
    if (registerForm.length > 0) {
        body.on('click touchend', '[name="--registration[__buttonIdentifier]"][value="login.submitButton"]', function (e) {
            e.stopPropagation();
            e.preventDefault();
            submitLogin();
            return false;
        });

        body.on('keydown', function (e) {
            var logincolumn = $(e.target).closest('#registration-login\\.column');
            var keycode = (e.keyCode ? e.keyCode : e.which);
            if (logincolumn.length > 0 && keycode == 13) {
                e.stopPropagation();
                e.preventDefault();
                submitLogin();
                return false;
            }
        });

        function submitLogin() {
            var emailField = $('#registration-login_email');
            var passwordField = $('#registration-login_password');
            var errorMessage = $('#login-error-message');

            emailField.prop('disabled', true);
            passwordField.prop('disabled', true);
            emailField.parent('.form-group').removeClass('has-error');
            passwordField.parent('.form-group').removeClass('has-error');
            errorMessage.addClass('d-none');

            $.ajax({
                url: $('[rel="avencyNwdAccountAuthenticateAction"]').attr('href'),
                data: {
                    __redirectAjaxSuccessUri: $('[rel="avencyNwdAccountAjaxSuccessAction"]').attr('href'),
                    __redirectAjaxFailureUri: $('[rel="avencyNwdAccountAjaxFailureAction"]').attr('href'),
                    __authentication: {
                        Neos: {
                            Flow: {
                                Security: {
                                    Authentication: {
                                        Token: {
                                            UsernamePassword: {
                                                username: emailField.val(),
                                                password: passwordField.val()
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
                method: 'post'
            }).done(function (data) {
                if (data.success) {
                    if (data.redirectUri) {
                        location.href = data.redirectUri;
                    } else {
                        location.href = $('[rel="avencyNwdAccountSuccessAction"]').attr('href');
                    }
                } else {
                    emailField.parent('.form-group').addClass('has-error');
                    passwordField.parent('.form-group').addClass('has-error');
                    errorMessage.removeClass('d-none');
                    emailField.prop('disabled', false);
                    passwordField.prop('disabled', false);
                }
            });
        }
    }

    /** Shopping List Listeners **/
    body.on('click touchend', '.btn-remove', function (e) {
        e.preventDefault();

        let listItem;
        const identifier = $(this).data('identifier');

        if (identifier !== undefined) {
            listItem = $('.shopping-list-item[data-identifier="' + identifier + '"], .product-list-item[data-identifier="' + identifier + '"], .product-gallery-item[data-identifier="' + identifier + '"]');
            removeListItems([listItem]);
            return;
        }

        listItem = $(this).parents('.shopping-list-item');
        removeListItems([listItem]);

        if ($(this).hasClass('btn-remove-cart-preview')) {
            reloadCartPreview();
        }
    });

    body.on('change', '.goto-uri-select', function (e) {
        var val = $(this).val();
        if (val !== 'none') {
            window.location.href = val;
        }

        $(this).prop('disabled', true);
        return false;
    });

    body.on('click touchend', '.user-product-list__item-details-link', function () {
        RenderModal.init('', $(this).next('div').html());

        return false;
    });

    $(body).on('click touchend', '.add-list-to-cart', function () {
        var val, sku = undefined;
        var quantities = {};
        $('.product-list-item').each(function () {
            sku = $(this).data('sku');
            val = $(this).find('input[type="number"]').first().val();
            if (val !== undefined && sku !== undefined && val > 0) {
                quantities[sku] = val + '';
            }
        });

        quantities = JSON.stringify(quantities);
        var redirectUrl = $(this).closest('.user-product-list').data('add-all-to-cart') + '&quantities=' + quantities;

        // trigger modal for blocked customers
        if ($(this).data('url') !== '') {
            $(this).data('quantities', quantities);
            $(this).data('redirect-url', redirectUrl);

            ajaxModal(this);
            return false;
        }

        $(this).attr('disabled', 'disabled');
        window.location.href = redirectUrl;
        return false;
    });

    $('div[data-show-add-all-to-cart="1"]').find('.add-list-to-cart').removeClass('d-none');

    updateItemStatistics();
}

function toggleFormOther(select) {
    var val = select.val();
    var isArray = $.isArray(val);
    var triggerValue = $(select).parents('[data-other-value]').data('other-value');
    triggerValue = String(triggerValue);

    if ((isArray && $.inArray(triggerValue, val) !== -1) || !isArray && val !== null && val.trim() == triggerValue) {
        select.closest('.form-group').next('.form-group').show();
        select.next().removeClass('open');
    } else {
        select.closest('.form-group').next('.form-group').hide();
    }
}

function updateItemStatistics() {
    var items = $('.fetch-units');
    if (items.length > 0) {
        var skus = [];
        items.each(function () {
            skus.push($(this).data('sku'));
        });

        var itemStatisticsUrl = items.first().data('item-statistics-url');

        $.ajax({
            url: itemStatisticsUrl,
            type: 'POST',
            data: {articles: skus},
            dataType: 'json',
            success: function (data) {
                var currentItem;
                items.removeClass('fetch-units');
                items.find('.current-year-units').html(0);
                items.find('.recent-order').html('');

                var detailsUri = $('.user-product-list').data('order-details');
                $.each(data, function (index, element) {
                    currentItem = items.filter(function () {
                        return ($(this).data('sku') == index);
                    });

                    currentItem.find('.current-year-units').html(element['units']);

                    var uri = detailsUri + '?order[__identity]=' + element['recentOrder']['orderIdentifier'];
                    var linkText = element['recentOrder']['creationDate'];
                    var link = '<a href="' + uri + '">' + linkText + '</a>';
                    currentItem.find('.recent-order').html(link);
                });
            }
        });
    }
}
window.updateItemStatistics = () => updateItemStatistics();

jQuery(function () {
    initialize();
});

if (typeof document.addEventListener === 'function') {
    document.addEventListener('Neos.PageLoaded', function (event) {
        initialize();
    }, false);
}

var viewer = [];

/**
 * Initialise Product Zoom (Zoom-Images)
 */
function initializeProductZoom(elements) {
    if (elements.length > 0) {
        resizeOpenSeadragon(elements);
        $.each(elements, function () {
            var imageWidth = $(this).data('width');
            var path = $(this).data('asset-path');
            path = path + '/';

            var settings = {
                element: this,
                prefixUrl: openSeadragonPrefixUrl + '/',
                navigationControlAnchor: OpenSeadragon.ControlAnchor.BOTTOM_RIGHT,
                showHomeControl: false,
                autoHideControls: false,
                showFullPageControl: false,
                tileSources: {
                    type: 'image',
                    url: $(this).data('image')
                },
                gestureSettingsMouse: {
                    scrollToZoom: false
                },
                gestureSettingsTouch: {
                    dragToPan: false,
                    scrollToZoom: false,
                    flickEnabled: false
                },
                gestureSettingsPen: {
                    dragToPan: false,
                    scrollToZoom: false,
                    flickEnabled: false
                },
                navImages: {
                    zoomIn: {
                        REST: path + 'zoomin_rest.png',
                        GROUP: path + 'zoomin_grouphover.png',
                        HOVER: path + 'zoomin_hover.png',
                        DOWN: path + 'zoomin_pressed.png'
                    },
                    zoomOut: {
                        REST: path + 'zoomout_rest.png',
                        GROUP: path + 'zoomout_grouphover.png',
                        HOVER: path + 'zoomout_hover.png',
                        DOWN: path + 'zoomout_pressed.png'
                    },
                    home: {
                        REST: 'home_rest.png',
                        GROUP: 'home_grouphover.png',
                        HOVER: 'home_hover.png',
                        DOWN: 'home_pressed.png'
                    },
                    fullpage: {
                        REST: path + 'fullpage_rest.png',
                        GROUP: path + 'fullpage_grouphover.png',
                        HOVER: path + 'fullpage_hover.png',
                        DOWN: path + 'fullpage_pressed.png'
                    },
                    rotateleft: {
                        REST: 'rotateleft_rest.png',
                        GROUP: 'rotateleft_grouphover.png',
                        HOVER: 'rotateleft_hover.png',
                        DOWN: 'rotateleft_pressed.png'
                    },
                    rotateright: {
                        REST: 'rotateright_rest.png',
                        GROUP: 'rotateright_grouphover.png',
                        HOVER: 'rotateright_hover.png',
                        DOWN: 'rotateright_pressed.png'
                    },
                    previous: {
                        REST: 'previous_rest.png',
                        GROUP: 'previous_grouphover.png',
                        HOVER: 'previous_hover.png',
                        DOWN: 'previous_pressed.png'
                    },
                    next: {
                        REST: 'next_rest.png',
                        GROUP: 'next_grouphover.png',
                        HOVER: 'next_hover.png',
                        DOWN: 'next_pressed.png'
                    }
                }
            };

            OpenSeadragon.setString("Tooltips.ZoomOut", "Verkleinern");
            OpenSeadragon.setString("Tooltips.ZoomIn", "Vergrößern");
            OpenSeadragon.setString("Tooltips.FullPage", "Vollbild");

            if (imageWidth > 456) {
                $(this).children('img').remove();
                var image = $(this).data('image');
                viewer[image] = OpenSeadragon(settings);
            }

            body.on('click touchend', '.product-thumbnails span.image-thumbnail, .product-thumbnails span.video-thumbnail', function () {
                var imageSrc = $(this).data('image');
                var imageWidth = $(this).data('width');
                var productGallery = $(this).closest('.product-gallery');
                var seadragon = productGallery.find('.main-image .openseadragon').first();
                var image = seadragon.find('img').first();

                var originalImage = $(seadragon).data('image');

                if (imageWidth > 456) {
                    if (viewer[originalImage] === undefined) {
                        $(seadragon).find('img').remove();
                        $(image).attr('src', imageSrc);
                        $(seadragon).data('image', imageSrc);
                        $(seadragon).data('width', imageWidth);
                        settings.tileSources.url = imageSrc;

                        viewer[originalImage] = OpenSeadragon(settings);
                    } else {
                        viewer[originalImage].close();
                        viewer[originalImage].open({
                            type: 'image',
                            url: $(this).data('image')
                        });
                    }
                } else {
                    if (viewer[originalImage] !== undefined) {
                        viewer[originalImage].destroy();
                        viewer[originalImage] = undefined;

                        image = $('<img width="720" height="600"/>');
                        seadragon.append(image);
                    }

                    $(image).attr('src', imageSrc);
                    $(seadragon).data('width', imageWidth);
                }
            })
        });
    }
}


/**
 * Resize OpenSeadragon Image
 */
function resizeOpenSeadragon(elements) {
    elements.each(function () {
        $(this).width('100%').height(Math.ceil($(this).width() / 6 * 5));
    });
}



/**
 * Open Product Video in the Modal-Box
 */
function openProductVideo(thisElement) {
    var id = $(thisElement).data('identifier');
    var videoTitle = $(thisElement).data('filename');
    var videoContent = $('#' + id).html();

    if (videoContent === undefined) {
        videoContent = $('#active-video_html5_api').html();
        RenderModal.init(videoTitle, videoContent);
    } else {
        RenderModal.init(videoTitle, videoContent);
    }

    videojs('#' + id, {}, function () {
        // Player (this) is initialized and ready.
    });
}
window.openProductVideo = (thisElement) => {
    openProductVideo(thisElement);
}

/** Shopping Lists **/

var tempList = undefined;

/**
 * Reloads the shopping cart summary
 *
 * @param element
 */
let reloadSummaryRequest = {};
function reloadSummary(element, callback) {
    let list = $(element);
    if (!list.hasClass('shopping-list')) {
        list = window.getListElement(element);
    }

    if (list.length) {
        tempList = list;
    } else {
        list = tempList;
    }

    if (list === undefined) {
        return;
    }

    const summary = window.getListSummaryElement(list);
    if (summary.length === 0) {
        return;
    }

    const url = list.data('summary-url') + '&cache=' + new Date().getTime();

	reloadSummaryRequest[list.data('summary-url')] = $.ajax({
        url: url,
		beforeSend: function () {
			if (reloadSummaryRequest[list.data('summary-url')] != null) {
				reloadSummaryRequest[list.data('summary-url')].abort();
				if (typeof callback == 'function') {
				    callback();
			        }
			}
		},
        success: function (data) {
            $(summary).replaceWith(data);

            const htmlChangedEvent = new CustomEvent('plandent.html.changed', {detail:{target:summary}});
            document.dispatchEvent(htmlChangedEvent);
        }
    });
}

window.reloadSummary = (list) => reloadSummary(list);

$('.shopping-list').data('request-count', 0);
$('.checkout-btn').data('href', $('.checkout-btn').attr('href'));
$('.shopping-list').on('change', '.bootstrap-touchspin', function(e) {
	$('.checkout-btn').addClass('disabled');
	$('.checkout-btn').attr('href', 'javascript:;');

	const element = $(e.currentTarget).find('input').first();

	if (!element.data('debounceTriggered')) {
		element.data('debounceTriggered', true);
		$('.shopping-list').data('request-count', $('.shopping-list').data('request-count') + 1);
	}

	let debounced = element.data('debouncedUpdate');

	if (!debounced) {
		debounced = _.debounce((el) => {
			const value = $(el).val();
			updateListItem(el, value);
			$(el).data('debounceTriggered', false);
		}, 1000, true);
		element.data('debouncedUpdate', debounced);
	}

	debounced(element);
});


/**
 * Update a list item and the list totals
 *
 * @param element
 * @param value
 */
function updateListItem(element, value) {
    const listItem = $(window.getListItemElement(element));
    const updateLink = listItem.data('updatelink');

    $.ajaxq('listitem', {
        url: updateLink,
        type: 'POST',
        data: {quantity: value},
        success: function (response) {
			const event = jQuery.Event("buy-data-quantity-change");
            event.itemId = response.itemId;
            event.quantity = response.quantity;
            event.updateElements = [];

            $(listItem).find('*[data-fetch-article-buy]').each(function () {
                event.updateElements.push($(this).data('articleBuy'));
            });

			event.callback = function () {
				reloadSummary(listItem, function () {
					$('.shopping-list').data('request-count', $('.shopping-list').data('request-count') - 1);
					if ($('.shopping-list').data('request-count') === 0) {
						$('.checkout-btn').attr('href', $('.checkout-btn').data('href'));
						$('.checkout-btn').removeClass('disabled');
						window.updateAnnotations();
					}
				});
			};

            $(window).trigger(event);
        }
    });
}

/**
 * Remove a list item
 *
 * @param elements
 * @param originList
 *
 * @deprecated Use ShoppingList.removeItemsFromShoppingList() instead
 */
function removeListItems(elements, originList) {
    const identifiers = [];
    const list = originList !== undefined ? originList : window.getListElement(elements[0]);

    const removeLink = list.data('removelink');
    const resetLink = list.data('remove-items-url');
    const updateSummary = list.data('update-summary');

    let url = resetLink;
    if (elements !== 'all') {
        elements.forEach(function (element) {
            identifiers.push($(element).data('identifier'));
        });

        url = removeLink;
    }

    $.ajaxq('listItem', {
        url: url,
        type: 'post',
        data: {identifiers: identifiers},
        beforeSend: function () {
            list.css('opacity', 0.15);
            list.prev('.loading-indicator').removeClass('d-none');
        },
        error: function (jqXHR, textStatus, errorThrown) {
            list.css('opacity', 1.0);
            list.prev('.loading-indicator').addClass('d-none');
        },
        success: function (response) {
            list.css('opacity', 1.0);
            list.prev('.loading-indicator').addClass('d-none');

            if (list.data('query-erp')) {
                $(list).erpShoppingBasket('loadBasket');
            }

            window.updateCartPreviewCount(response);

            if (updateSummary !== false) {
                reloadSummary(list);
                updateCheckoutButtons(response.checkout.hasNormalItems, response.checkout.hasRequestItems);
                toggleShoppingCarts(list, response.checkout.hasNormalItems, response.checkout.hasRequestItems);
            }

            window.updateAnnotations();

            if (elements !== 'all') {
                elements.forEach(function (element) {
                    $(element).prev('.pharmaceuticalsWarning').remove();
                    $(element).parent('.nwd-table__list-item').remove();
                    $(element).remove();
                });
            } else {
                $(list).find('.product-list-item').remove();
                $(list).find('.pharmaceuticalsWarning').remove();
            }

            if ($(list).find('.product-list-item').length === 0) {
                $(list).find('.empty-list-notice').show();
            }
        }
    })
}

/** Mini Shopping Cart **/

var cartPreviewRequest = null;

/**
 * Reload the cart preview dropdown contents
 */
function reloadCartPreview() {
    const cartPreview = $('div.cart-preview');

    let updateLink = $(cartPreview).data('updatelink');
    if (typeof updateLink == "undefined") {
        return;
    }

    updateLink = updateLink + '&cache=' + new Date().getTime();
    const loadingIndicator = $(cartPreview).find('.dropdown-menu .loading-indicator');
    const dropDownMenu = $(cartPreview).find('.dropdown-menu .content');

    dropDownMenu.hide();
    loadingIndicator.show();

    cartPreviewRequest = $.ajax({
        url: updateLink,
        beforeSend: function () {
            if (cartPreviewRequest != null) {
                cartPreviewRequest.abort();
            }
        },
        success: function (response) {
            loadingIndicator.hide();
            $(dropDownMenu).html(response);

            $(dropDownMenu).find('.price-async').prices();
            $(dropDownMenu).find('*[data-fetch-article-buy]').articleBuy();

            dropDownMenu.show();

            const itemCount = $(dropDownMenu).find('ul').data('item-count');
            $('.cart-preview-count').html(itemCount);
        }
    });

    updateValueDiscountCountdown();
}

function toggleShoppingCarts(list, hasNormalItems, hasRequestItems) {
    list = $(list);

    var listIdentifier = list.data('list-id');
    if (listIdentifier === 'default' && !hasNormalItems && hasRequestItems) {
        list.addClass('d-none');
    } else if (listIdentifier === 'requestOffers') {
        if (!hasRequestItems) {
            list.addClass('d-none');
            $('.shopping-list[data-list-id="default"]').removeClass('d-none');
        } else if (!hasNormalItems) {
            $('.shopping-list[data-list-id="default"]').addClass('d-none');
        }
    }
}
window.toggleShoppingCarts = (list, hasNormalItems, hasRequestItems) => {
    toggleShoppingCarts(list, hasNormalItems, hasRequestItems);
}

function updateCheckoutButtons(hasNormalItems, hasRequestItems) {
    var onlyRequestItems = !hasNormalItems && hasRequestItems;
    var hasBoth = hasNormalItems && hasRequestItems;

    $('main .checkout-btn').addClass('d-none');
    if (onlyRequestItems) {
        $('main .checkout-btn-request').removeClass('d-none');
    } else if (hasBoth) {
        $('main .checkout-btn-both').removeClass('d-none');
    } else {
        $('main .checkout-btn-normal').removeClass('d-none');
    }
}
window.updateCheckoutButtons = (hasNormalItems, hasRequestItems) => {
    updateCheckoutButtons(hasNormalItems, hasRequestItems);
}

/**
 * Update the value discount countdown message on product/article pages
 */
function updateValueDiscountCountdown() {
    var discountCountdowns = $('.value-discount-countdown');
    var updateUrl = discountCountdowns.first().data('update-url');

    if (discountCountdowns.length < 1) {
        return;
    }

    $.get(updateUrl, function (response) {
        discountCountdowns.each(function () {
            $(this).replaceWith(response);
        })
    }, '');
}

/** Shopping Buttons **/

/**
 * Add item to cart
 *
 * @param linkElement the "a" element that has been clicked
 * @param cartPreviewUpdate weather to update the cart preview or not
 * @param data data to be added to the request
 */
function addToCart(linkElement, cartPreviewUpdate, data) {
    if ($(linkElement).attr('disabled') === 'disabled') {
        return;
    }

    if (!data) {
        data = {};
    }

    var addLink = $(linkElement).data('url');
    var input = $(linkElement).siblings('.input-group').find('input');

    if ($(input).length !== 0) {
        data.quantity = $(input).val();
    }

    // Get product node for the add all to cart function
    var product = $('.product-variants[data-product]');
    if ($(product).length && $(linkElement).hasClass('add-all-btn')) {
        data.node = $(product).data('product');
    }

    // Get filters for the add all to cart function
    var filter = $.fn.requestArguments().getArgument('filter');
    if (typeof filter != 'undefined') {
        data.filter = filter;
    }

    // Get checkout page uri and add it to the dropup. Needed for the add all to cart button
    var checkoutUri = $('.product-variants[data-checkout-link]');
    if ($(checkoutUri).length !== null) {
        $('.checkout-link').attr('href', $(checkoutUri).data('checkout-link'));
    }

    $(linkElement).attr('disabled', true);
    $(linkElement).find('i').removeClass('ai-shopping-cart');
    $(linkElement).find('i').addClass('ai-refresh');

    $.ajaxq('cartInsert', {
        url: addLink,
        data: data,
        type: 'post',
        success: function (response) {
            if (cartPreviewUpdate) {
                window.updateCartPreviewCount(response);
                $(input).val(1);
            }

            $('.dropup.open').trigger('hide.bs.dropdown');

            const dropup = $(linkElement).closest('.dropup');
            const success = $(dropup).find('.success');

            if (response !== undefined && response.isAdjustedToMinQuantity) {
                const minQuantityText = success.data('min-quantity');
                success.html(minQuantityText.replace('#quantity#', response.minQuantity));
            } else if (response !== undefined && response.isAdjustedToMaxQuantity) {
                const maxQuantityText = success.data('max-quantity');
                success.html(maxQuantityText.replace('#quantity#', response.maxQuantity));
            } else {
                success.html(success.data('default'));
            }

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                    'currencyCode': 'EUR',
                    'add': {
                        'products': [{
                            'name': response.name,
                            'id': response.itemId,
                            'price': response.price,
                            'brand': response.manufacturer,
                            'quantity': response.quantity
                        }]
                    }
                }
            });

            dropup.addClass('open');
            dropup.trigger('shown.bs.dropdown');

            const cartAddedEvent = new CustomEvent('plandent.cart.added', {detail: {itemId: response.itemId}});
            document.dispatchEvent(cartAddedEvent);

            $(linkElement).find('i').addClass('icon-shopping-cart');
            $(linkElement).find('i').removeClass('icon-refresh');
            $(linkElement).attr('disabled', false);

            setCookie('reloadCart', 'true');
        }
    });
}


$('#country-modal-wrapper').each(function () {
    var popupContent = $(this).html();
    RenderModal.init('', popupContent);

    $('.choose-country-popup label').on('click', function () {
        var label = $(this);
        var input = label.siblings('input')[0];

        label.addClass('active');
        input.focus();
        if ($(input).is(':checked')) {
            $(input).prop('checked', false);
        } else {
            $(input).prop('checked', true);
        }
    });
});

$('.delete-shopping-list').on('click touchend', function () {
    var modalcontent = $(this).prev('.confirmationmodal');
    var popupContent = modalcontent.html();

    var confirmDelete = modalcontent.find('.confirm').text();
    var confirmCancel = modalcontent.find('.abort').text();

    RenderModal.init(
        '',
        popupContent,
        {
            confirm: {
                label: confirmDelete,
                className: 'btn-primary',
                callback: function () {
                    window.location = modalcontent.find('.confirm').attr('href');
                }
            },
            cancel: {
                label: confirmCancel,
                className: 'btn-default',
                callback: function () {
                }
            }
        },
        false,
        'medium'
    );
});

/**
 * Repair-Service
 * doppelter Content wird ausgeblendet
 */
if ($('.repair-service-submitted').length > 1) {
    $('.repair-service-submitted').not(':first').addClass('d-none');
}

/**
 * Warenkorb & Produktliste Dropdown Menü
 */
body.on('click touchend', '.delete-selected', function (e) {
    $('.minimal-shopping-cart__selectAll-checkbox').toggle();
    $('.select-item-check').toggle();
    $('.minimal-shopping-cart__gear').hide();
    $('.dropdown-column-toggle').hide();

    e.preventDefault();
});

body.on('click touchend', '.select-abort', function (e) {
    $('.minimal-shopping-cart__selectAll-checkbox').hide();
    $('.select-item-check').hide();
    $('.minimal-shopping-cart__gear').show();
    $('.dropdown-column-toggle').show();
    $('.checkItem').prop('checked', false);

    e.preventDefault();
});

/**
 *  Shopping List checkbox Listeners
 */

$('.select-all-loaded-items').on('click touchend', function (e) {
    $('.checkItem').prop('checked', true);
    e.preventDefault();
});

$('.deselect-all-items').on('click touchend', function (e) {
    $('.checkItem').prop('checked', false);
    e.preventDefault();
});

/**
 *  Shopping List delete selected articles
 */
$('.shoppingCart-delete-selected').on('click touchend', function (e) {
    var itemNodes = [];
    $("input:checkbox[name='checkItem']:checked").each(function () {
        itemNodes.push(window.getListItemElement(this));
    });

    if (itemNodes.length > 0) {
        var confirmationModal = $('.confirmationmodal');
        if (confirmationModal.length < 1) {
            return;
        }

        var modalContent = confirmationModal[0];

        var confirmDelete = $(modalContent).find($('.confirm-delete')).text();
        var confirmCancel = $(modalContent).find($('.confirm-cancel')).text();

        var content = $(modalContent).html();
        RenderModal.init(
            '',
            content,
            {
                confirm: {
                    label: confirmDelete,
                    className: 'btn-primary',
                    callback: function () {
                        $(".dropdown.open").removeClass("open");
                        $(".select-abort").trigger("click");
                        removeListItems(itemNodes);
                    }
                },
                cancel: {
                    label: confirmCancel,
                    className: 'btn-default',
                    callback: function () {
                    }
                }
            },
            false,
            'small'
        );

        e.preventDefault();
    }
});

/**
 * Function to retrieve a get parameter from the current document (using location.href)
 *
 * @param parameter {String} Key of the get parameter to retrieve
 */
function _get(parameter) {
    var reg = new RegExp('[?&]' + parameter + '=([^&#]*)', 'i');
    var string = reg.exec(window.location.href);
    return string ? string[1] : undefined;
}

/**
 * Init fast checkout modal
 */
function initFastCheckoutModal() {
    $('.fast-checkout-modal .checkout-type-radio').on('click', function () {
        const checkoutType = $(this).val();
        if (checkoutType === 'fast') {
            $('.fast-checkout-modal .show-on-default').addClass('d-none');
            $('.fast-checkout-modal .show-on-fast').removeClass('d-none');
        } else {
            $('.fast-checkout-modal .show-on-default').removeClass('d-none');
            $('.fast-checkout-modal .show-on-fast').addClass('d-none');
        }
    })

    $('.fast-checkout-modal .save-and-close').on('click', function (e) {
        var form = $(this).closest('form');
        var checkoutBtn = $('.fast-checkout-btn');

        $(this).attr('disabled', 'disabled');

        $.ajax({
            type: "POST",
            url: form.attr('action'),
            data: form.serialize(),
            success: function() {
                checkoutBtn.data('toggle', '');
                checkoutBtn.trigger('click');
                checkoutBtn.attr('disabled', 'disabled');
                bootbox.hideAll();
            }
        });

        e.preventDefault();
    })
}

const shippingAndPayment = $('.shipping-and-payment');
shippingAndPayment.on('click', '.shipping-address-select .shipping-address-type-radio', function () {
    const addressType = $(this).val();
    var paymentType = 'invoice';
    var selectedIdentifier = undefined
    var useInvoiceAddress = addressType === 'useInvoiceAddress';
    if (useInvoiceAddress) {
        $('.shipping-address-select .show-on-other-address').addClass('d-none');
        $('.shipping-address-select .show-on-invoice-address').removeClass('d-none');

        const isInternational = $('.shipping-address-select .show-on-invoice-address').data('international');
        if (isInternational) {
            paymentType = 'prepayment';
        }
    } else {
        $('.shipping-address-select .show-on-invoice-address').addClass('d-none');
        $('.shipping-address-select .show-on-other-address').removeClass('d-none');

        selectedIdentifier = $('.shipping-address-select .selectpicker').val();
        const selectedAddress = $('.shipping-address[data-address="' + selectedIdentifier + '"]');

        if (selectedAddress.data('international')) {
            paymentType = 'prepayment';
        }
    }

    saveAndReloadStandardShippingCosts(useInvoiceAddress, selectedIdentifier);
    showPaymentMethod(paymentType);
})

shippingAndPayment.on('changed.bs.select', '.shipping-address-select .selectpicker', function () {
    const selectedIdentifier = $(this).val();
    $('.shipping-address:not(.d-none)').addClass('d-none');
    const address = $('.shipping-address[data-address="' + selectedIdentifier + '"]');
    address.removeClass('d-none');

    var paymentType = 'invoice';
    if (address.data('international')) {
        paymentType = 'prepayment';
    }

    saveAndReloadStandardShippingCosts(false, selectedIdentifier);
    showPaymentMethod(paymentType);
});

function saveAndReloadStandardShippingCosts(useInvoiceAddress, address) {
    $.ajaxq('selectAddress', {
        url: $('.shipping-and-payment').data('change-address-url'),
        method: 'POST',
        data: {'useInvoiceAddress': useInvoiceAddress, 'address': address},
        success: function () {
            reloadStandardShippingCosts();
        }
    });
}

function reloadStandardShippingCosts() {
    const standaloneUrl = $('.shipping-and-payment').data('delivery-costs');
    $.get(standaloneUrl, function (data) {
        $('.shipping-and-payment .default-shipping').replaceWith(data);

        const popovers = document.querySelectorAll('.shipping-and-payment .default-shipping [data-bs-toggle="popover"]');

        if (popovers.length) {
            Array.from(popovers).forEach((popoverEl) => {
                const popover = new Popover(popoverEl, {
                    container: 'body'
                });
            });
        }
    });
}

function showPaymentMethod(paymentType) {
    $('.shipping-and-payment .payment-type').addClass('d-none');
    $('.shipping-and-payment .payment-type[data-payment-type="' + paymentType + '"]').removeClass('d-none');
}

body.on('click', '.create-shipping-address-modal .submit-button', function () {
    var btn = $(this)
    $('.create-shipping-address-modal form').submit(function (e) {
        btn.attr('disabled', 'disabled');
        e.preventDefault();

        const form = $(this);
        const url = form.attr('action');

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(),
            success: function (data) {
                if (data.indexOf('<form') > -1) {
                    $('.create-shipping-address-modal').replaceWith(data);
                    $('select.selectpicker').selectpicker({
                        style: ''
                    });
                    return;
                }

                const standaloneUrl = $('.shipping-address-select').data('standalone');
                $.get(standaloneUrl, function (data) {
                    $('.shipping-address-select').replaceWith(data);
                    $('select.selectpicker').selectpicker({
                        style: ''
                    });

                    shippingAddressModal.modal('hide');
                });

                reloadStandardShippingCosts();
            }
        });
    });
});

var shippingAddressModal = null;

shippingAndPayment.on('click', '.shipping-address-select .create-shipping-address-btn', function () {
    $(this).attr('disabled', 'disabled');
    const that = this;

    $.get($(this).attr('href'), function (data) {
        shippingAddressModal = RenderModal.init('', data);
        $('select.selectpicker').selectpicker({
            style: ''
        });

        $(that).removeAttr('disabled');
    });

    return false;
});

function ajaxModal(element) {
    var url = $(element).data('url');
    var additionalData = $(element).data();

    RenderModal.init(
        '',
        '<div class="modal-content-loading"></div>',
        null,
        false,
        null,
        null,
        null,
        (e) => {
            const bootboxBody = e.target.querySelector('.bootbox-body');
            e.target.classList.add('loading');

            $.ajax(url, {data: additionalData}).done(function (data) {
                bootboxBody.innerHTML = data;
                e.target.classList.remove('loading');

                const htmlChangedEvent = new CustomEvent('plandent.html.changed', {detail:{target:e.target}});
                document.dispatchEvent(htmlChangedEvent);
            });
        }
    );
}

document.addEventListener('plandent.html.changed', (e) => {

    const target = e.detail.target;

    if(!target) {
        return;
    }

    $(target).find('select.selectpicker').selectpicker({style:''});

    $(target).find('select').each(function () {
        toggleFormOther($(this));
    });

    $(target).find('select').on('change', function () {
        toggleFormOther($(this));
    });
    var inputs = $(target).find('input');
    if (inputs.length > 0) {
        inputs.inputPlaceholderPolyfill();
    }
});

body.on('click', '[data-toggle="ajax-modal"],[data-bs-toggle="ajax-modal"]', function () {
    var input = $(this).siblings('.input-group').find('input');
    if ($(input).length !== 0) {
        $(this).data('quantity', $(input).val());
    }

    if (!$(this).data('toggle')) {
        return true;
    }

    ajaxModal(this);
    return false;
});

body.on('click touchend', '#requestEmailInvoices [data-bs-toggle="readonly"]', function () {
    console.log('clear readonly');

    var target = $(this).data('bs-target');
    $(target).removeAttr('readonly');
    $(target).focus();
    $(this).attr('disabled', 'disabled');

    return false;
});

/**
 * Article page
 * Prevent IE11 flexbox issues:
 */
(function initArticlePage() {
    // Detect if we are in the main arean
    $('main').inViewport(function(v,e) {
        if (v){
            $(e).addClass('in-viewport');
        } else {
            $(e).removeClass('in-viewport');
        }
    });

    // Detect if the cart button is visible
    $('.article-header-actions .shopping-button-async').inViewport(function(v,e) {
        if (v){
            $('body').removeClass('show-article-footer-actions');
        }  else {
            $('body').addClass('show-article-footer-actions');
        }
    });

    // Init scrollspy for tabs by article detail sections
    if(document.getElementById('js-scrollspy')) {
        // remove tabs with same textContent
        var uniqueKeys = [];
        $('#js-scrollspy .article-content-tabs > li').each(function(idx, elem) {
            var key = $(elem).data('key');
            if(key) {
                if (uniqueKeys.indexOf(key) > -1) {
                    $(elem).remove();
                }
                uniqueKeys.push(key);
            }
        })

        $('#js-scrollspy .article-content-tabs').each(function(idx, elem) {
            if ($(elem).find('li').length === 0) {
                $(elem).remove();
            }
        });

        new ScrollSpy('#js-scrollspy', {
            nav: '.article-content-tabs > li > a',
            className: 'is-inview',
            callback: function(state) {
                var viewStatusList = state.viewStatusList || [];
                var oldIndex = $('.underline-animated').data('active-index') || 0;
                var activeIndex = -1;

                for (var i = 0; i < viewStatusList.length ; i++) {
                    if(viewStatusList[i]){
                        activeIndex = i;
                        break;
                    }
                }

                var newIndex = (activeIndex > -1 ? activeIndex : oldIndex);
                var width = $($('.article-content-tabs li')[newIndex]).width();

                var offset =  0;
                for (var i = 0; i < newIndex; i++) {
                    offset += $($('.article-content-tabs li')[i]).width();
                }

                $('.underline-animated').data('active-index', newIndex).css('marginLeft', offset).width(width);
            }
        });

        // Load variants
        $('#article-content-layer-variants').ajaxVariants();
    }

    // Disable collapsible article detail sections on desktop
    $('.article-content-section > h3 + div').on('hide.bs.collapse show.bs.collapse', function (e) {
        if(window.checkViewport('min-width: 992px')){
            e.preventDefault();
        }
    });

})();

// Get video content out of the way
$(body).append($('.article-gallery-images .videoplayer').detach());

function initArticleGallerySlider() {
    let slideCount = 2;

    if (window.Viewport.mediaBreakpointUp('lg')) {
        slideCount = 4;
    }
    if (window.Viewport.mediaBreakpointUp('xxl')) {
        slideCount = 5;
    }

    if ($('.article-gallery-images .slick-wrapper.slick-initialized').length){
        $('.article-gallery-images .slick-wrapper.slick-initialized').slick('unslick');
    }

    if ($('.article-gallery-images .slick-wrapper > *').length > slideCount) {
        $('.article-gallery-images .slick-wrapper').slick({
            infinite: false,
            slidesToShow: slideCount,
            slidesToScroll: slideCount,
            prevArrow: '<span class="nwd-slick-arrow nwd-slick-arrow-prev"><span class="ai ai-menu-left"></span></span>',
            nextArrow: '<span class="nwd-slick-arrow nwd-slick-arrow-next"><span class="ai ai-menu-right"></span></span>',
        });
    }
}

$(window).on('buy-data-loaded-all', function () {
    $('.shopping-list-totals').each(function () {
        reloadSummary($(this))
    })

    if (!window.checkViewport('max-width: 767px')) {
        document.dispatchEvent(new Event('plandent.articles.setHeights'));
    }
})

$('.data-layer-push').on('buy-data-loaded', function (e) {
    window.dataLayer = window.dataLayer || [];
    const price = e.price;
    if (price === undefined) {
        return;
    }

    const layer = $(this).data('layer');
    const layerStr = JSON.stringify(layer).replaceAll('%unitPrice%', price.unitPrice)

    const layers = JSON.parse(layerStr);
    layers.forEach(function (l) {
        window.dataLayer.push(l);
    })
});

$('.cart-preview').on('show.bs.dropdown', function () {
    reloadCartPreview();
});
